module.exports = __webpack_public_path__ + "img/advantage-banner.f40ae9a6.jpg";